import config from '../config';

export const SET_LAYER_SHOW = 'SET_LAYER_SHOW';
export const SET_LAYER_OPACITY = 'SET_LAYER_OPACITY';
export const SET_LAYER_WEIGHT = 'SET_LAYER_WEIGHT';

export const setLayerShow = (id, value) => ({ type: SET_LAYER_SHOW, payload: { id, value } });
export const setLayerOpacity = (id, value) => ({ type: SET_LAYER_OPACITY, payload: { id, value } });
export const setLayerWeight = (id, value) => ({ type: SET_LAYER_WEIGHT, payload: { id, value } });

export const getMapLayers = (state) => state.mapLayers;

const initialState = config.layers;

const findLayer = (state, id) => state.find((layer) => layer.id === id);

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_LAYER_SHOW:
      findLayer(state, payload.id).show = payload.value;
      return;
    case SET_LAYER_OPACITY:
      findLayer(state, payload.id).opacity = payload.value;
      return;
    case SET_LAYER_WEIGHT:
      findLayer(state, payload.id).weight = payload.value;
      return;
    default:
      return state;
  }
};
